module.exports = __webpack_public_path__ + "static/media/strongher7.ced3f2e1.jpg";